import { PASSWORDLESS_REGISTER, PERSONALIZATION_API_KEY } from './constants';

interface PasswordlessRegisterResponse {
  pianoUid: string;
  accessToken: string;
  expiresIn: Date;
}

const passwordlessRegister = async (email: string, registrationConsent: string) => {
  const url = `${PASSWORDLESS_REGISTER}?email=${email}&registrationConsent=${registrationConsent}`;
  const response = await fetch(url, {
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'POST',
  });

  if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

  return (await response.json()) as PasswordlessRegisterResponse;
};

export default passwordlessRegister;
